<script setup>
import { computed, ref } from "vue";

const props = defineProps({
  items: {
    type: Object,
  },
  selectedItems: {
    type: Array,
  },
  title: {
    type: String,
    default: "",
  },
  itemLabel: {
    type: String,
    default: "label",
  },
  itemValue: {
    type: String,
    default: "value",
  },
  //   searchText: {
  //     type: String,
  //     default: "",
  //   },
});

const emit = defineEmits(["update:selectedItems"]);

// const innerSearchText = computed({
//   get: () => props.searchText,
//   set: (val) => {
//     emit("update:searchText", val);
//   },
// });

const innerSelectedItems = computed({
  get: () => {
    return props.selectedItems;
  },
  set: (val) => emit("update:selectedItems", val),
});

const searchText = ref("");

const filteredItems = computed(() => {
  const trimmedLowercaseSearchText = searchText.value.trim().toLowerCase();
  const noText = !!!trimmedLowercaseSearchText;
  if (noText) {
    return props.items;
  }
  const itemsCopy = { ...props.items };
  Object.entries(props.items).forEach(([key, item]) => {
    const lowercaseLabel = item[props.itemLabel].toLowerCase();
    const noMatch = lowercaseLabel.indexOf(trimmedLowercaseSearchText) < 0;
    if (noMatch) {
      delete itemsCopy[key];
    }
  });
  return itemsCopy;
});
</script>

<template>
  <v-card :style="{ height: '100%' }">
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{ title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-text-field
            class="text_field header"
            outlined
            dense
            :label="$t('searchMessage')"
            append-icon="mdi-undo-variant"
            @click:append="searchText = ''"
            v-model="searchText"
          />
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item-group
        v-if="!!Object.keys(filteredItems).length"
        v-model="innerSelectedItems"
        multiple
        :style="{
          height: '320px',
          overflow: 'auto',
        }"
      >
        <v-list-item
          v-for="item in filteredItems"
          :value="item[itemValue]"
          :key="item[itemValue]"
          dense
        >
          <v-list-item-content>
            {{ item[itemLabel] }}
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
      <v-list-item v-else class="secondaryText--text">
        {{ $t("noItemsMsg") }}
      </v-list-item>
    </v-list>
  </v-card>
</template>
